//@ts-nocheck
export const ACADEMIC_PREFERENCES = {
  classes: [
    "Pre-primary",
    "Lower Primary",
    "Upper Primary",
    "Junior Secondary",
    "Senior Secondary",
    "Tertiary",
    "Adult",
  ],
  curriculums: ["Montessori", "EYFS", "British", "Nigerian", "American"],
  examPrep: {
    Primary: {
      title: "Upper Primary Exams",
      options: [
        "Common Entrance Exams",
        "11+ Entrance Exams",
        "Cambridge Primary Exams",
      ],
    },
    JSS: {
      title: "Junior Secondary Exams",
      options: ["JSSCE/BECE", "Cambridge Checkpoint", "13+ Entrance Exams"],
    },
    SSS: {
      title: "Senior Secondary Exams",
      options: [
        "WAEC/JAMB/NECO/JUPEB",
        "IGCSE-Cambridge A/Levels",
        "SAT/PSAT- Reasoning Test",
        "ACT- College Test",
        "SAT II - Subject Tests",
        "Edexcel - International A/Levels",
        "IB - International BAccalaureate",
        "AP - Advanced Placement Exams",
      ],
    },
  },
};

export const TEACHING_PREFERENCES = {
  classes: [
    "Infants (0 - 2)",
    "Kids (3 - 7)",
    "Pre-teens (8 - 12)",
    "Teenagers (13 - 19)",
    "Adults (20 and above)",
  ],
  levels: ["Beginner", "Intermediate", "Advanced", "Native"],
  dialect: ["Scottish", "American", "Latin American", "Ijebu"],
  purposes: ["Business", "Academic test prep", "Culture"],
  exams: [
    "WAEC/JAMB/NECO/JUPEB",
    "IGCSE-Cambridge A/Levels",
    "SAT/PSAT- Reasoning Test",
    "ACT- College Test",
    "SAT II - Subject Tests",
    "Edexcel - International A/Levels",
    "IB - International BAccalaureate",
    "AP - Advanced Placement Exams",
  ],
  instrument_types: ["Guitar", "Piano", "Flute"],
};

export const TUTOR_PROFILE_PREFERENCES = (
  category: "Academics" | "Test Prep" | "Languages" | "Music",
  isLiteTutor?: boolean
) => {
  return {
    Academics: [
      {
        heading: "Class groups",
        subHeading: `What class of learners do you teach?`,
        name: "classes",
        options: isLiteTutor
          ? ACADEMIC_PREFERENCES.classes.filter(
              (o) => !["Tertiary", "Adult"].includes(o)
            )
          : ACADEMIC_PREFERENCES.classes,
        type: "multiselect",
        required: true,
      },
      {
        heading: "Academic curriculum",
        subHeading: `Select the curriculum(s) you teach in and give a short description of your expertise.`,
        options: ACADEMIC_PREFERENCES.curriculums,
        name: "curriculums",
        // type: "multiselect",
        type: "accordion-multi",
        reasonLabel:
          "Give a descriptive summary of your experience and qualification in teaching this specific curriculum.",
        accordionFieldName: "curriculum_explanation",
        required: true,
      },
      {
        heading: "Examination boards",
        name: "exam_speciality",
        subHeading:
          "Indicate the exams you have successfully prepared students for or skip this step if it doesn't apply to you.",
        options: [
          {
            heading: "Upper Primary Exams",
            options: [
              "Common Entrance Exams",
              "11+ Entrance Exams",
              "Cambridge Primary Exams",
            ],
          },
          {
            heading: "Junior Secondary Exams",
            options: [
              "JSSCE/BECE",
              "Cambridge Checkpoint",
              "13+ Entrance Exams",
            ],
          },
          {
            heading: "Senior Secondary Exams",
            options: [
              "WAEC/JAMB/NECO/JUPEB",
              "IGCSE-Cambridge A/Levels",
              "SAT/PSAT- Reasoning Test",
              "ACT- College Test",
              "SAT II - Subject Tests",
              "Edexcel - International A/Levels",
              "IB - International Baccalaureate",
              "AP - Advanced Placement Exams",
            ],
          },
        ],
        type: "multiselect",
        complex: true,
      },
      {
        heading: "School entrance exams",
        name: "schools_taught",
        subHeading: `If you've prepared students for entrance into secondary or tertiary schools, please list the schools here separated by commas.`,
        type: "input",
      },
    ],
    Languages: [
      {
        heading: "Age groups",
        subHeading: `Select the age of learners that your lessons are best suited for`,
        options: TEACHING_PREFERENCES.classes,
        name: "classes",
        type: "multiselect",
      },
      {
        heading: "Student objectives",
        subHeading: `Which of these purposes are your lessons best suited for? Select all that apply`,
        options: TEACHING_PREFERENCES.purposes,
        name: "purpose",
        type: "multiselect",
      },
      {
        heading: "Languages exams",
        subHeading:
          "If applicable, please select which of these exams you have successfully prepared students for",
        options: TEACHING_PREFERENCES.exams,
        name: "exam",
        type: "multiselect",
      },
    ],
    Music: [
      {
        heading: "Age groups",
        subHeading: `Select the age of learners that your lessons are best suited for`,
        options: TEACHING_PREFERENCES.classes,
        name: "classes",
        type: "multiselect",
      },
      {
        heading: "Music exams",
        subHeading:
          "If applicable, please select which of these exams you have successfully prepared students for",
        options: TEACHING_PREFERENCES.exams,
        name: "exam",
        type: "multiselect",
      },

      {
        heading: "Musical studio",
        subHeading:
          "Do you have access to a studio that can be used for lessons? If yes, ensure to upload images under the Subject Photos section",
        name: "studio",
        type: "radio",
        options: ["Yes", "No"],
      },
    ],
  }[category];
};
